import { toReadableLabel } from "./contactOptionLabel";

export type PersonTitleFields = {
  title?: string | null;
  listTitle?: string | null;
  /** Cosmos stores a string; legacy IPerson types it as boolean. */
  unlistedTitle?: string | boolean | null;
};

export type PersonCatalogNameFields = {
  honorary?: string | null;
  name?: string | null;
  lastName?: string | null;
};

/** Catalog/grid summary name: honorary title + first + last (suffix excluded). */
export function formatPersonCatalogDisplayName(
  person: PersonCatalogNameFields,
): string {
  return [person.honorary, person.name, person.lastName]
    .map((part) => toReadableLabel(part))
    .filter(Boolean)
    .join(" ");
}

function toTrimmedString(value: unknown): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed || undefined;
}

/** Display title for professionals: prefers custom unlisted title over catalog "Other". */
export function resolvePersonDisplayTitle(
  person: PersonTitleFields,
  fallback = "Partner",
): string {
  const unlisted = toTrimmedString(person.unlistedTitle);
  if (unlisted) {
    return unlisted;
  }

  const list = toTrimmedString(person.listTitle);
  if (list) {
    return list;
  }

  const title = toTrimmedString(person.title);
  if (title && title.toLowerCase() !== "other") {
    return title;
  }

  return fallback;
}
